var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStik(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1728,
    height: 171,
    viewBox: "0 0 1728 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M854.5 62C247.303 62 0 171 0 171H1728C1728 171 1461.7 62 854.5 62Z",
    fill: "url(#paint0_radial_421_83)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M831.13 91.9934C829.079 87.9543 826.006 86.7218 824.266 89.2404C822.525 91.7591 822.777 97.0751 824.828 101.114L849.934 150.56C851.451 153.548 853.527 155 855.21 154.534C856.892 155 858.969 153.548 860.486 150.56L885.592 101.114C887.643 97.0753 887.895 91.7593 886.155 89.2406C884.414 86.722 881.341 87.9545 879.29 91.9936L855.21 139.419L831.13 91.9934Z",
    fill: "url(#paint1_linear_421_83)",
    fillOpacity: 0.63
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M863.032 4L854.492 61.6442",
    stroke: "white",
    strokeWidth: 6.93865,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M861.605 17.8645L886.711 32.7059",
    stroke: "white",
    strokeWidth: 6.93865,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M857.335 61.5379L882.441 90.9999",
    stroke: "white",
    strokeWidth: 6.93865,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M832.249 32.7059L857.355 17.8645",
    stroke: "white",
    strokeWidth: 6.93865,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M827.979 91L853.085 61.538",
    stroke: "white",
    strokeWidth: 6.93865,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_421_83",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(858.5 62) rotate(90) scale(100.5 858.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153949,
    stopColor: "#7D9DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304994,
    stopColor: "#4467D1",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_421_83",
    x1: 855.21,
    y1: 87.9689,
    x2: 855.21,
    y2: 104.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.13
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStik);
export default __webpack_public_path__ + "static/media/stik.d3579f95de2c09f972a3aebce0a54691.svg";
export { ForwardRef as ReactComponent };